import { render, staticRenderFns } from "./ScenarioInsight.vue?vue&type=template&id=2d5d76fa&scoped=true&"
import script from "./ScenarioInsight.vue?vue&type=script&lang=js&"
export * from "./ScenarioInsight.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioInsight.vue?vue&type=style&index=0&id=2d5d76fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d76fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsItems } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDialog,
  VIcon,
  VTab,
  VTabItem,
  VTabs,
  VTabsItems,
})
